import * as React from 'react';
import { observer } from 'mobx-react';
import { configConsumer, ITranslationsCollection, translate } from '@estee/elc-service';
import { IShopNowButton, IShopNowButtonConfig } from '../../interfaces/IProductCTA';
import { StyledShopNowButton } from './ProductCTAStyles';
import { classes } from '../../utils/Classes';

export const ShopNowButton = configConsumer(['translationsOverwrites'])(
    translate(['shopNowButtonLabel'])(
        observer(function ShopNowButton(props: IShopNowButton) {
            const ShopNowButtonClassNames = classes('shop-now-button');
            const { onShopNowClick, translations } = props;
            const { translationsOverwrites } = props.config as IShopNowButtonConfig;
            const { shopNowButtonLabel } = translations as ITranslationsCollection;
            const customCtaLabel = translationsOverwrites && translationsOverwrites.ctaButtonLabel;
            const shopNowLabel = customCtaLabel || shopNowButtonLabel;

            return (
                <StyledShopNowButton className={ShopNowButtonClassNames} onClick={onShopNowClick}>
                    {shopNowLabel}
                </StyledShopNowButton>
            );
        })
    )
);
